"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BiometricsChannel = void 0;
const topic_1 = require("../../topic");
const BIOMETRICS_CHANNEL = "biometrics";
class BiometricsChannel {
    constructor(_logger) {
        this._logger = _logger;
        this.channel = BIOMETRICS_CHANNEL;
        this.topics = {
            biometricsStatus: new topic_1.Topic("biometricsStatus", this.channel, this._logger),
            enrollment: new topic_1.Topic("enrollment", this.channel, this._logger),
            enrollmentFinished: new topic_1.Topic("enrollmentFinished", this.channel, this._logger),
            enrollmentStatus: new topic_1.Topic("enrollmentStatus", this.channel, this._logger),
            requestToken: new topic_1.Topic("requestToken", this.channel, this._logger),
            biometricSettings: new topic_1.Topic("biometricSettings", this.channel, this._logger),
            loginIntent: new topic_1.Topic("loginIntent", this.channel, this._logger),
            login: new topic_1.Topic("login", this.channel, this._logger),
            loginCancelled: new topic_1.Topic("loginCancelled", this.channel, this._logger)
        };
    }
}
exports.BiometricsChannel = BiometricsChannel;
//# sourceMappingURL=biometrics.channel.js.map